// extracted by mini-css-extract-plugin
export default {"container":"note_container__L3-dV","label":"note_label__cxqvj","error":"note_error__RRmO0"};